import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'

SwiperCore.use([Navigation])

export default class ProductHalfVideoSlider {
  constructor(component) {
    this.dom = {
      $component: component,
      $section: component.querySelector('.js-ProductHalfVideoSlider'),
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.loadProducts()
  }

  initSlider(container) {

    const { dom } = this
    new Swiper(container, {
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
      },
      slidesPerView: 'auto',
      navigation: {
        prevEl: dom.$component.querySelector('.js-productSliderPrev'),
        nextEl: dom.$component.querySelector('.js-productSliderNext'),
      },
    })
  }

  loadProducts() {
    const { dom } = this
    const mountCards = new Event('mountproductcards')
    const slides = window.basis.ProductHalfVideoSlider.slides
    const container = dom.$section.querySelector('.js-productHalfSliderContainer')
    container.querySelector('.swiper-wrapper').innerHTML = slides
    this.initSlider(container)
    document.dispatchEvent(mountCards)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductHalfVideoSlider = this
  }
}
